// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29Asa","rootMobile":"styles_rootMobile__37hy6"};